export default __webpack_public_path__ + "static/media/tasks_overdue.e2598ba0.svg";